<template>
  <div>
    <ts-card>
      <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
        <h4 class="ts-text-sm">
          {{ $t('administration.employee.attendanceShift.showDetails') }}
        </h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <ts-loading-banner :loading="loadingPreData">
        <div class="row">
          <div class="col-md-12">
            <div id="container-table">
              <table class="table ui-table table-hover">
                <thead>
                  <tr>
                    <th style="width:10%">
                      {{
                        $t('administration.employee.attendanceShift.keyword')
                      }}
                    </th>
                    <th>
                      {{
                        $t('administration.employee.attendanceShift.fromDay')
                      }}
                    </th>
                    <th>
                      {{ $t('administration.employee.attendanceShift.toDay') }}
                    </th>
                    <th style="width:12%">
                      {{
                        $t('administration.employee.attendanceShift.firstIn')
                      }}
                    </th>
                    <th style="width:12%">
                      {{
                        $t('administration.employee.attendanceShift.firstOut')
                      }}
                    </th>
                    <th style="width:12%">
                      {{
                        $t('administration.employee.attendanceShift.secondIn')
                      }}
                    </th>
                    <th style="width:12%">
                      {{
                        $t('administration.employee.attendanceShift.secondOut')
                      }}
                    </th>
                    <th style="width:20%">
                      {{
                        $t('administration.employee.attendanceShift.TotalHours')
                      }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in model.details" :key="index">
                    <td>
                      <ts-input type="text" v-model="item.keyword" class="form-control-plaintext" />
                    </td>
                    <td>
                      <select v-model="item.wd_id_from" class="form-control ts-w-32">
                        <option value="">{{ $t('select') }}</option>
                        <option v-for="(weekDay, index) in weekDays" :key="index" :value="weekDay.wd_id_from">
                          {{ weekDay }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <select v-model="item.wd_id_from" class="form-control ts-w-32">
                        <option value="">{{ $t('select') }}</option>
                        <option v-for="(weekDay, index) in weekDays" :key="index" :value="weekDay.wd_id">
                          {{ weekDay.wd_name_en }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <ts-input v-model="item.first_in" class="form-control-plaintext" />
                    </td>
                    <td>
                      <ts-input v-model="item.first_out" class="form-control-plaintext" />
                    </td>
                    <td>
                      <ts-input v-model="item.second_in" class="form-control-plaintext" />
                    </td>
                    <td>
                      <ts-input v-model="item.second_out" class="form-control-plaintext" />
                    </td>
                    <td>
                      <input :value="totalHour(item).description" class="form-control-plaintext" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ts-loading-banner>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'shift-management-show',
  props: ['showData'],
  data() {
    return {
      model: {
        shift_name: '',
        shift_type: null,
        minute_allow: '',
        // weekDays: [],
        details: []
      },
      loadingPreData: false
    }
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  computed: {
    ...mapState('attendanceShift', ['weekDays']),
    ...mapGetters('attendanceShift', ['totalHour', 'tConvert'])
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.loadingPreData = true
      this.$store
        .dispatch('attendanceShift/dataBeforeCreate')
        .then(response => {
          this.loadingPreData = false
          this.setShowData()
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    setShowData() {
      if (!_.isEmpty(this.showData)) {
        this.model = {
          shift_name: this.showData.shift_name,
          shift_type: this.showData.shift_type,
          minute_allow: this.showData.minute_allow,
          details: []
        }
        this.showData.details.map(el => {
          this.model.details.push({
            keyword: el.keyword,
            wd_id_from: el.wd_id_from,
            wd_id_to: el.wd_id_to,
            first_in: this.tConvert(el.first_in),
            first_out: this.tConvert(el.first_out),
            second_in: this.tConvert(el.second_in),
            second_out: this.tConvert(el.second_out),
            total_hour: el.total_hour
          })
        })
      }
    }
  }
}
</script>
<style lang="css" scoped>
/* This is to remove the arrow of select element in IE */
select::-ms-expand {
  display: none;
}

select {
  -webkit-appearance: none;
  appearance: none;
}
</style>
